var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-top-class",class:{ 'tap-top': _vm.tapTop },on:{"click":function($event){return _vm.scrollToTop()}}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"img-fluid",attrs:{"src":"/images/svg/global/top-arrow.svg","alt":"top"}})])
}]

export { render, staticRenderFns }